'use client';

import { VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/routing';
import appConst from '~/const/appConst';

export const ChidrenFormAddBtn = () => {
  const t = useTranslations('PROFILE.NAVIGATION');

  return (
    <div className="children-form__add-button">
      <Link
        className="vp-button vp-button--tertiary vp-button--small vp-button--squared button-wrapper-link"
        href={appConst.staticRoutes.children_profile}
        passHref
        prefetch={false}
      >
        <span className="vp-button__label" data-part="label">
          <div data-part="start-slot">
            <VpIcon name="add" />
          </div>
          {t('ADD_CHILDREN')}
        </span>
      </Link>
    </div>
  );
};
